/* NPB Buy Box — Natures Pure Blend
   - Opens from any link to #npb-buy or element with [data-npb-open]
   - Step 1 picks an option block → Step 2 shows that product's subscription plan(s)
   - "See another option" reveals the one-time purchase for the selected option
   - Checkout: optional cart clear → /cart/add.js (with selling_plan) → /checkout (or /cart)
*/
/* NPB buy box v4 — form checkout, no AJAX add */
(function () {
  function init(root) {
    if (!root || root.__npb) return; root.__npb = true;
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var moneyFmt = root.getAttribute('data-money') || '${{amount}}';
    var state = { opt: null, sel: null, upsell: false, perks: {} };
    var step1 = $('[data-npb-step="1"]'), step2 = $('[data-npb-step="2"]');
    var cfTimer, wgTimer;
    var sectionEl = root.closest('[id^="shopify-section-"]');
    var designMode = !!(window.Shopify && Shopify.designMode);

    function money(cents) {
      cents = Math.round(cents || 0);
      var fmt = function (n, d, t, dec) { var s = (n / 100).toFixed(d).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return s[0] + (s[1] ? dec + s[1] : ''); };
      return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        switch (k) {
          case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
          default: return fmt(cents, 2, ',', '.');
        }
      });
    }

    /* ---------- open / close ---------- */
    function pin() {
      /* Some apps put a CSS transform on a page wrapper (mostly on desktop), which makes a fixed overlay
         scroll away with the page. Move the overlay to <body> and, if it still isn't pinned, pin it by hand. */
      if (!designMode && root.parentNode !== document.body) document.body.appendChild(root);
      root.style.top = ''; root.style.height = ''; root.style.bottom = '';
      var t = root.getBoundingClientRect().top;
      if (Math.abs(t) > 1) { root.style.top = (-t) + 'px'; root.style.bottom = 'auto'; root.style.height = window.innerHeight + 'px'; }
    }
    function open() {
      root.hidden = false; document.documentElement.classList.add('npb-bb-open');
      pin(); show(1);
    }
    window.addEventListener('resize', function () { if (!root.hidden) pin(); });
    function close() {
      root.hidden = true; document.documentElement.classList.remove('npb-bb-open');
      if (location.hash === '#npb-buy') history.replaceState(null, '', location.pathname + location.search);
    }
    function show(n) {
      step1.hidden = n !== 1; step2.hidden = n !== 2;
      root.scrollTop = 0;
    }
    /* capture phase: runs before any theme/app click handler can swallow the click */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#npb-buy"], a[href*="#npb-buy"], [data-npb-open]');
      if (a && !root.contains(a)) { e.preventDefault(); e.stopPropagation(); open(); }
    }, true);
    window.addEventListener('hashchange', function () { if (location.hash === '#npb-buy') open(); });
    if (location.hash === '#npb-buy') open();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    $('[data-npb-close]').addEventListener('click', close);
    $('[data-npb-back]').addEventListener('click', function () { if (!step2.hidden) show(1); else close(); });

    /* ---------- step 1 ---------- */
    var cont = $('[data-npb-continue]');
    function pick(id) {
      state.opt = id;
      $$('[data-npb-pick]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.npbPick === id ? 'true' : 'false'); });
      cont.disabled = !id;
    }
    $$('[data-npb-pick]').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.npbPick); }); });
    var def = $('[data-npb-pick][data-default]'); if (def) pick(def.dataset.npbPick);
    var info = $('[data-npb-info]');
    if (info) info.addEventListener('click', function () { var t = $('[data-npb-info-text]'); t.hidden = !t.hidden; info.setAttribute('aria-expanded', String(!t.hidden)); });
    cont.addEventListener('click', function () { if (!state.opt) return; enterStep2(); show(2); });

    /* ---------- step 2 ---------- */
    function panel() { return $('[data-npb-panel="' + state.opt + '"]'); }
    function onceEl() { return $('[data-npb-once="' + state.opt + '"]'); }
    function firstPlan() { var p = panel(); return p && p.querySelector('[data-npb-plan]'); }
    /* the "best" option = biggest pack (3 months); the switch button and savings message use it */
    function bestId() { var b = $('[data-npb-pick][data-npb-best]'); return b ? b.dataset.npbPick : null; }
    function bestPlan() { var id = bestId(), p = id && $('[data-npb-panel="' + id + '"]'); return p && p.querySelector('[data-npb-plan]'); }
    function enterStep2() {
      $$('[data-npb-panel]').forEach(function (p) { p.hidden = p.dataset.npbPanel !== state.opt; });
      var fp = firstPlan();
      state.sel = fp ? 'plan:' + fp.dataset.npbPlan : (onceEl() ? 'once' : null);
      setMore(!fp && !!onceEl());   // no subscription available → show one-time straight away
      render();
    }
    function setMore(openIt) {
      var btn = $('[data-npb-more]'); btn.setAttribute('aria-expanded', String(openIt));
      $$('[data-npb-once]').forEach(function (o) { o.hidden = !(openIt && o.dataset.npbOnce === state.opt); });
      btn.style.display = onceEl() ? '' : 'none';
    }
    function currentPrice() {
      if (state.sel === 'once') { var o = onceEl(); return o ? +o.dataset.price : 0; }
      var p = panel(), el = p && p.querySelector('[data-npb-plan="' + (state.sel || '').split(':')[1] + '"]');
      return el ? +el.dataset.price : 0;
    }
    function render() {
      var p = panel(); if (!p) return;
      $$('[data-npb-plan]', p).forEach(function (s) {
        var on = state.sel === 'plan:' + s.dataset.npbPlan;
        s.classList.toggle('is-on', on); s.querySelector('[data-npb-sel]').setAttribute('aria-checked', String(on));
      });
      var o = onceEl();
      $$('[data-npb-once] [data-npb-sel]').forEach(function (b) { b.setAttribute('aria-checked', String(state.sel === 'once' && b.closest('[data-npb-once]') === o)); });
      // savings banner (only when one-time is selected and a subscription exists)
      var save = $('[data-npb-save]'), fp = bestPlan() || firstPlan();
      var tEl = $('[data-npb-save-text]'), tpl = (o && o.dataset.save) || (tEl && tEl.dataset.tpl) || '';   /* per-option message wins */
      if (state.sel === 'once' && o && tpl.indexOf('[amount]') === -1) {
        /* fixed message (e.g. "You could save $44 every 3 months") — same on every option */
        tEl.textContent = tpl; save.hidden = !tpl || !fp;
      } else if (state.sel === 'once' && fp && o) {
        /* compare per bottle, then show it over the 3-month plan's shipment */
        var bu = +fp.dataset.units || 1, ou = +o.dataset.units || 1;
        var diff = (+o.dataset.price / ou - +fp.dataset.price / bu) * bu;   /* savings over one 3-month shipment */
        if (diff > 0) {
          var t = $('[data-npb-save-text]'); t.textContent = tpl.replace('[amount]', money(diff));
          save.hidden = false;
        } else save.hidden = true;
      } else save.hidden = true;
      // perks
      $$('[data-npb-perk]').forEach(function (b) { if (!(b.dataset.npbPerk in state.perks)) state.perks[b.dataset.npbPerk] = b.getAttribute('aria-checked') !== 'false'; b.setAttribute('aria-checked', String(state.perks[b.dataset.npbPerk])); });
      // total
      var up = $('[data-npb-upsell]'), total = currentPrice() + (state.upsell && up ? +up.dataset.price : 0);
      var tot = $('[data-npb-total]'); if (tot) tot.textContent = money(total);
    }
    root.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-npb-sel]'); if (sel && root.contains(sel)) { state.sel = sel.dataset.npbSel; render(); return; }
      var pk = e.target.closest('[data-npb-perk]'); if (pk) { state.perks[pk.dataset.npbPerk] = !state.perks[pk.dataset.npbPerk]; render(); return; }
    });
    $('[data-npb-change]') && $$('[data-npb-change]').forEach(function (b) { b.addEventListener('click', function () { show(1); }); });
    $('[data-npb-more]').addEventListener('click', function () {
      var openIt = this.getAttribute('aria-expanded') !== 'true'; setMore(openIt);
      if (!openIt && state.sel === 'once' && firstPlan()) state.sel = 'plan:' + firstPlan().dataset.npbPlan;
      render();
    });
    $('[data-npb-switch]').addEventListener('click', function () {
      var id = bestId();
      if (id && bestPlan()) { pick(id); enterStep2(); setMore(false); render(); var r = root; r.scrollTop = 0; return; }
      var fp = firstPlan(); if (fp) { state.sel = 'plan:' + fp.dataset.npbPlan; setMore(false); render(); }
    });

    /* ---------- upsell + confetti ---------- */
    var up = $('[data-npb-upsell]');
    function setUpsell(on, celebrate) {
      state.upsell = on; up.setAttribute('aria-pressed', String(on)); render();
      if (on && celebrate) {
        if (root.dataset.confetti !== 'false') burst();
        if (root.dataset.wiggle !== 'false') { clearTimeout(wgTimer); wiggle(); wgTimer = setTimeout(wiggle, 1900); }
      }
    }
    if (up) { up.addEventListener('click', function () { setUpsell(!state.upsell, true); }); if (up.hasAttribute('data-default')) setUpsell(true, false); }
    function burst() {
      var box = $('[data-npb-confetti]') || document.querySelector('.npb-cf-layer');
      if (!box) { box = document.createElement('div'); }
      /* move the layer to <body> so no parent (scroll container, transform, theme wrapper) can clip or hide it on desktop */
      if (box.parentNode !== document.body) { box.removeAttribute('data-npb-confetti'); box.className = 'npb-bb__confetti npb-cf-layer'; document.body.appendChild(box); }
      box.innerHTML = '';
      var cols = ['#FF8A3D', '#FFB27F', '#46C8AF', '#8FE3CF', '#F4F8F6', '#FFD166'];
      var W = Math.min(window.innerWidth, 1400) / 1440;
      for (var i = 0; i < 120; i++) {
        var a = Math.random() * Math.PI * 2, d = (180 + Math.random() * 580) * Math.max(W, .45);
        var s = document.createElement('span'), w = [6, 8, 10, 12][i % 4], round = Math.random() < .2;
        s.className = 'npb-cf';
        s.style.cssText = 'width:' + w + 'px;height:' + (round ? w : [4, 6, 10, 14][i % 4]) + 'px;border-radius:' + (round ? '50%' : '2px') + ';background:' + cols[i % cols.length] +
          ';--dx:' + Math.round(Math.cos(a) * d) + 'px;--dy:' + Math.round(Math.sin(a) * d * .75 - 120) + 'px;--rot:' + ((Math.random() < .5 ? -1 : 1) * (360 + Math.random() * 540)) + 'deg;animation-duration:' + (1.6 + Math.random() * .3).toFixed(2) + 's;animation-delay:' + (Math.random() * .08).toFixed(2) + 's';
        box.appendChild(s);
      }
      clearTimeout(cfTimer); cfTimer = setTimeout(function () { box.innerHTML = ''; }, 2000);
    }
    function wiggle() { var b = $('[data-npb-checkout]'); if (!b) return; b.classList.remove('npb-wiggle'); void b.offsetWidth; b.classList.add('npb-wiggle'); }

    /* ---------- checkout ---------- */
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    $('[data-npb-checkout]').addEventListener('click', function () {
      var btn = this, err = $('[data-npb-error]'); err.hidden = true;
      var items = [], p = panel(); if (!p) return;
      if (state.sel === 'once') {
        var o = onceEl(); if (!o) return; items.push({ id: +o.dataset.variant, quantity: 1 });
      } else {
        var planId = (state.sel || '').split(':')[1], pl = p.querySelector('[data-npb-plan="' + planId + '"]'); if (!pl) return;
        items.push({ id: +pl.dataset.variant, quantity: 1, selling_plan: +planId });
        /* perks: only checked perks that have a product picked are added (e.g. eBook products); no text/properties are sent */
        var seen = {};
        $$('[data-npb-perk]', pl).forEach(function (b) { var v = +b.dataset.variant; if (v && state.perks[b.dataset.npbPerk] && !seen[v]) { seen[v] = 1; items.push({ id: v, quantity: 1 }); } });
      }
      if (state.upsell && up && up.dataset.variant) { var u = { id: +up.dataset.variant, quantity: 1 }; if (up.dataset.plan) u.selling_plan = +up.dataset.plan; items.push(u); }
      btn.classList.add('is-loading');
      /* Go straight to checkout with a normal form POST (not AJAX) — slide carts only react to AJAX cart calls. */
      document.documentElement.classList.add('npb-going');
      var f = document.createElement('form'); f.method = 'POST'; f.action = root_url + 'cart/add'; f.style.display = 'none';
      function field(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
      items.forEach(function (it) { field('items[][id]', it.id); field('items[][quantity]', it.quantity); if (it.selling_plan) field('items[][selling_plan]', it.selling_plan); });
      field('return_to', root_url + (root.dataset.redirect === 'cart' ? 'cart' : 'checkout'));
      document.body.appendChild(f);
      /* Clearing uses a clean fetch from a hidden same-origin iframe, so cart apps that hook window.fetch/XHR never see it. */
      function rawFetch(url, opt) { try { var fr = document.createElement('iframe'); fr.style.display = 'none'; document.body.appendChild(fr); var fx = fr.contentWindow.fetch.bind(fr.contentWindow); return fx(url, opt).finally(function () { fr.remove(); }); } catch (e) { return fetch(url, opt); } }
      var chain = root.dataset.clear === 'true' ? rawFetch(root_url + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      chain.then(function () { HTMLFormElement.prototype.submit.call(f); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) { btn.classList.remove('is-loading'); document.documentElement.classList.remove('npb-going'); } });
    });

    /* ---------- theme editor preview ---------- */
    document.addEventListener('shopify:section:select', function (e) { if (sectionEl === e.target) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (sectionEl === e.target) close(); });
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return; open();
      var pickBtn = e.target.closest('[data-npb-pick]'); if (pickBtn) { pick(pickBtn.dataset.npbPick); show(1); return; }
      if (e.target.closest('[data-npb-perk]')) { if (!state.opt) { var f = $('[data-npb-pick]'); if (f) pick(f.dataset.npbPick); } enterStep2(); show(2); }
    });
  }
  function boot() { document.querySelectorAll('[data-npb-bb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
